import type { TOC } from '@ember/component/template-only';

import DesignerLeftPanelComponent from 'webapp/components/designer/left-panel';
import DesignerRightPanelComponent from 'webapp/components/designer/right-panel';
import DesignerTopbarContainerComponent from 'webapp/components/designer/topbar/container';
import type DesignerController from 'webapp/controllers/designer';

interface Args {
	controller: DesignerController;
}

const DesignerRouteTemplate: TOC<Args> = <template>
	<DesignerTopbarContainerComponent
		@selectedBoard={{@controller.board}}
		@selectedBoardLoop={{@controller.loop}}
		@disableBoardsDropdown={{@controller.disableBoardsDropdown}}
		@onBoardUpdate={{@controller.saveBoard}}
		@onBoardChange={{@controller.openBoard}}
		@onBoardLoopChange={{@controller.openLoop}}
		@onExitDesigner={{@controller.exitDesigner}}
	/>

	<div id="main" class={{if @controller.areBothSidebarsOpen "both-sidebars-open"}}>

		{{outlet}}

		{{#if @controller.navigationService.initialRequestsDone}}

			<DesignerLeftPanelComponent
				@boardState={{@controller.boardState}}
				@isOpen={{@controller.isLeftSidebarOpen}}
				@onPanelToggle={{@controller.toggleLeftSidebar}}
				@activeDatawallGrid={{@controller.activeDatawallGrid}}
				@preselectedSourceFromWizard={{@controller.preselectedSource}}
				@setNewBlockPositionAndSize={{@controller.setNewBlockPositionAndSize}}
			/>

			<DesignerRightPanelComponent
				@boardState={{@controller.boardState}}
				@isOpen={{@controller.isRightSidebarOpen}}
				@onPanelClose={{@controller.closeRightSidebar}}
			/>

		{{/if}}

	</div>
</template>;

export default DesignerRouteTemplate;
